import { EditResultsComponent } from './edit-results/edit-results.component';
import { AddResultsComponent } from './add-results/add-results.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListResultsComponent } from './list-results/list-results.component';

export const routesResults: Routes = [
    { path: 'results', component: ListResultsComponent},
    { path: 'results/add', component: AddResultsComponent},
    { path: 'results/:id/edit', component: EditResultsComponent}
];

export const ResultsRoutes: ModuleWithProviders = RouterModule.forChild(routesResults);
